var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13H12.1667M12.1667 13H25.5M12.1667 13V24.6667C12.1667 25.1087 12.3423 25.5326 12.6548 25.8452C12.9674 26.1577 13.3913 26.3333 13.8333 26.3333H22.1667C22.6087 26.3333 23.0326 26.1577 23.3452 25.8452C23.6577 25.5326 23.8333 25.1087 23.8333 24.6667V13H12.1667ZM14.6667 13V11.3333C14.6667 10.8913 14.8423 10.4674 15.1548 10.1548C15.4674 9.84227 15.8913 9.66667 16.3333 9.66667H19.6667C20.1087 9.66667 20.5326 9.84227 20.8452 10.1548C21.1577 10.4674 21.3333 10.8913 21.3333 11.3333V13M16.3333 17.1667V22.1667M19.6667 17.1667V22.1667",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e6a5c7ecd2b6870a4da2b2fc5db988e3.svg";
export { ForwardRef as ReactComponent };